define(function (require) {
	var IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/generic/',
		url: function () {
			var url = this.urlRoot;
			if (this.moniker)
				url = url + this.moniker;
			if (this.sendAsQueryString) {
				var data = this.toJSON();
				url = url + '?{0}'.format($.param(data));
			}

			if (this.selects) {
				url = url + '?select=[{0}]'.format(this.selects);
			}
			return url;
		},
		parse(response) {
			this.removeProp(response.data, '__type');
		},
		//hopefully temporary code to remove the __type variable and fees object in lookup.
		removeProp: function (obj, propToDelete) {
			for (var property in obj) {
				if (property === propToDelete) {
					delete obj[property];
				} else if (typeof obj[property] == 'object') {
					delete obj.property;
					let newJsonData = this.removeProp(obj[property], propToDelete);
					obj[property] = newJsonData;
				}
			}
			return obj;
		}
	});
});
